import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Header, Button, Loader, Card } from 'semantic-ui-react'
import styled from 'styled-components'

import MerchandiseCodeCard from './components/Card'
import MerchandiseCodeForm from './components/Form'
import MerchandiseCodeDetail from './components/Detail'

import MerchandiseCodeActions from '../../../reducers/merchandiseCodeReducer'

const Wrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 0 15px;
`

const HeaderWrapper = styled.div`
  margin-bottom: 14px
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

class MerchandiseCodes extends Component {
  state = {
    modalAddVisible: false,
    modalDetailVisible: false,
    viewData: null,
  }

  componentDidMount() {
    const { loaded, getMerchandiseCodes } = this.props

    if (!loaded) getMerchandiseCodes()
  }

  render() {
    const { loaded, merchandiseCodes } = this.props
    const { modalAddVisible, modalDetailVisible, viewData } = this.state
    const merchandiseCodeCount = Object.keys(merchandiseCodes).length

    if (!loaded) return <Loader active />

    return (
      <Wrapper className="hide-scrollbar">
        <HeaderWrapper>
          <Header size="large" style={{ display: 'inline-block' }}>
            Merchandise Codes <strong>({merchandiseCodeCount})</strong>
          </Header>
          <Button
            icon="add"
            color="black"
            onClick={() => this.setState({ modalAddVisible: true })}
          />
        </HeaderWrapper>

        <Card.Group>
          {
            Object.values(merchandiseCodes).map(merchandiseCode => (
              <MerchandiseCodeCard
                key={merchandiseCode.id}
                merchandiseCode={merchandiseCode}
                onViewClick={() => this.setState({ viewData: merchandiseCode, modalDetailVisible: true })}
              />
            ))
          }
        </Card.Group>

        {modalAddVisible && (
          <MerchandiseCodeForm visible={modalAddVisible} onClose={() => this.setState({ modalAddVisible: false })} />
        )}

        {modalDetailVisible && (
          <MerchandiseCodeDetail
            visible={modalDetailVisible}
            data={viewData}
            onClose={() => this.setState({ modalDetailVisible: false, viewData: null })}
          />
        )}
      </Wrapper>
    )
  }
}

const mapState = ({ merchandiseCodes }) => ({
  merchandiseCodes: merchandiseCodes.data,
  loaded: merchandiseCodes.loaded,
})

const mapDispatch = {
  getMerchandiseCodes: MerchandiseCodeActions.getMerchandiseCodes,
}

export default connect(mapState, mapDispatch)(MerchandiseCodes)



// WEBPACK FOOTER //
// ./src/containers/rewards/MerchandiseCodes/index.js